const micrositeSubmissionDefaultState = {
  data: {},
  loading: false,
  error: false,
  success: false,
  successMessage: '',
  errorMessage: null,
};

const micrositeSubmissionReducer = (state = micrositeSubmissionDefaultState, action) => {
  switch(action.type) {
    case 'START_GET_MICROSITE_SUBMISSION':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'GET_MICROSITE_SUBMISSION_SUCCESS':
      return {
        ...state,
        data: action.micrositeSubmission,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case 'START_CREATE_MICROSITE_SUBMISSION':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'CREATE_MICROSITE_SUBMISSION_SUCCESS':
      return {
        ...state,
        data: action.micrositeSubmission,
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: 'Your account has been created!',
      };
    case 'START_MICROSITE_SUBMISSION_UPDATE':
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'MICROSITE_SUBMISSION_UPDATE_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.micrositeSubmission
        },
        loading: false,
        success: true,
        error: false,
        errorMessage: null,
        successMessage: '',
      };
    case 'SHOW_ERROR':
      return {
        ...state,
        loading: false,
        error: true,
        successMessage: '',
        errorMessage: action.errorMessage
      };
    default:
      return state;
  }
};

export default micrositeSubmissionReducer;